"use client";

import { cn, Icon } from "@kyan/ui";
import { type MouseEventHandler } from "react";

import styles from "./ToggleButton.module.scss";

export type ToggleButtonVariant = "primary" | "secondary";

export interface ToggleButtonProps {
  active: boolean;
  variant: ToggleButtonVariant;
  onToggle: MouseEventHandler<HTMLButtonElement>;
}

export const ToggleButton: React.FC<ToggleButtonProps> = ({
  active,
  variant,
  onToggle,
}) => {
  if (variant === "secondary") {
    return (
      <button className="mr-4" onClick={onToggle}>
        <Icon
          name={active ? "collapse" : "expand"}
          className="hover:text-textPrimary transition-colors hover:cursor-pointer"
        />
      </button>
    );
  }

  return (
    <div
      className={cn(
        "relative h-full rounded-t-md p-px pb-0",
        styles.gradientBackgroundOptions,
      )}
    >
      <button
        className="bg-background hover:text-textPrimary flex h-full cursor-pointer items-center gap-1.5 rounded-t-md px-5 transition-colors"
        onClick={onToggle}
      >
        <span className="text-xs">{active ? "Close" : "Open"}</span>
        <Icon
          name="caret-down"
          className={cn("text-xxs transition-transform", {
            "rotate-180": !active,
          })}
        />
        {/* Horizontal lines to cover the border gradients on the bottom side */}
        <div className="bg-background absolute right-0 bottom-px left-0 mx-auto h-1 w-[calc(100%-4px)]" />
        <div className="bg-divider absolute bottom-0 left-0 h-px w-full" />
      </button>
    </div>
  );
};
